<div class="document-translations-notification">
  <div class="notification-dt">
    <div class="notification-right-container">
      <h2 class="notification-header">For Official Translations</h2>
      <p class="notification-info-one">
        To comply with ISO standards, IT security, and privacy policies, only approved machine translation (MT) tools may be used within Thermo Fisher.
      </p>
      <p class="notification-info-two">
        Documents that fall into the following categories are considered 'Official translations' and must be processed through Language Services
      </p>
      <p class="notification-link">
        <a href="https://thermofisher.sharepoint.com/sites/LanguageServices" target="blank">
          <img src="assets/icons/instrument/instrument.svg" alt="Icon/Science/Instrument">
          <strong>Language Services</strong>
        </a>
      </p>
      <ul class="notification-info-three">
        <li>Translation of a document where the translation will become a reference (source) document</li>
        <li>Legally-binding documents</li>
        <li>Documents intended for regulatory audiences or containing regulated materials, including regulated marketing materials</li>
        <li>Documents intended for study participants, study sites, or study clinicians</li>
        <li>Client and customer-facing documents</li>
      </ul>
    </div>
  </div>
</div>
